import {
  FormGroup,
  IconName,
  InputGroup,
  MaybeElement,
} from "@blueprintjs/core";
import React from "react";
import { RelativityTooltip } from "../../../Tooltip/RelativityTooltip";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { FieldLabeledProps, TextProps } from "../../types/fieldTypes";
import { useTextField } from "./useTextField";

export interface TextFieldProps extends TextProps {
  leftIcon?: IconName | MaybeElement;
  inputMode?:
    | "search"
    | "text"
    | "none"
    | "tel"
    | "url"
    | "email"
    | "numeric"
    | "decimal";
  isSensitive?: boolean;
  sanitize?: (value: string | undefined) => string | undefined;
  labelProps?: FieldLabeledProps;
  disableToolTip?: boolean;
}

const TextField: React.FC<TextFieldProps> = (props) => {
  const {
    localValue,
    isTooltipVisible,
    textInputRef,
    isSensitiveAndDisabled,
    determineInputType,
    setMaskOnBlur,
    shouldShowMaskedIcon,
    handleOnChange,
    showRequiredBackground,
    errorMessages,
  } = useTextField(props);

  return (
    <div
      className={`ucl-base-input-text-field-container${
        props.className ? ` ${props.className}` : ""
      }`}
    >
      <RelativityTooltip
        shouldShowTooltip={
          isTooltipVisible &&
          !isSensitiveAndDisabled() &&
          props.disableToolTip !== true
        }
        content={!!localValue ? localValue : ""}
      >
        <FormGroup
          className={
            showRequiredBackground ? "has-required-background" : "base-field"
          }
        >
          {props.label && (
            <FieldLabel
              labelName={props.label}
              tooltipDescription={props.description}
              fieldProps={{ ...props, value: localValue }}
              isRequired={props.isRequired}
              {...props.labelProps}
            />
          )}
          <InputGroup
            inputRef={textInputRef}
            type={determineInputType()}
            value={localValue ?? ""}
            inputMode={props.inputMode}
            disabled={props.disabled}
            placeholder={props.placeholder}
            maxLength={props.maxLength === 0 ? undefined : props.maxLength}
            leftIcon={props.leftIcon}
            readOnly={props.readOnly}
            onChange={(e) => {
              if (e.target.value != localValue) {
                handleOnChange(e.target.value);
              }
            }}
            rightElement={shouldShowMaskedIcon()}
            onBlur={() => setMaskOnBlur()}
            minLength={props.minLength}
          />
          {errorMessages && (
            <FormFieldErrorContainer errorMessages={errorMessages} />
          )}
        </FormGroup>
      </RelativityTooltip>
    </div>
  );
};

export default TextField;
